import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#2C2E2D] group-[.toaster]:text-[#D9D9D9] group-[.toaster]:border-[#818881] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#D9D9D9]",
          actionButton:
            "group-[.toast]:bg-[#CCF751] group-[.toast]:text-[#2C2E2D] group-[.toast]:border-[#CCF751]",
          cancelButton:
            "group-[.toast]:bg-[#818881] group-[.toast]:text-[#D9D9D9]",
          success: 
            "group-[.toast]:border-l-[#CCF751] group-[.toast]:border-l-2",
          error: 
            "group-[.toast]:border-l-red-500 group-[.toast]:border-l-2",
          info: 
            "group-[.toast]:border-l-[#D9D9D9] group-[.toast]:border-l-2",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
